import { body, breakpoint, canvas, heading, spacing, text } from '@carvana/ds-styles';
import styled from 'styled-components';

export const Background = styled.div`
  background-color: ${canvas.default};
  display: flex;
  margin: ${spacing['4Xl']} ${spacing['2Xl']};
  flex-direction: column;
  align-items: center;
  gap: 0px;
  align-self: stretch;

  @media screen and (min-width: ${breakpoint.md}) {
    margin: ${spacing['7Xl']} ${spacing['2Xl']};
  }

  @media screen and (min-width: ${breakpoint.lg}) {
    margin: ${spacing['7Xl']} ${spacing['4Xl']};
  }
`;

export const Container = styled.div`
  display: flex;
  max-width: 1272px;
  width: 100%;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing['4Xl']};
`;

export const ContentLockup = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing['2Xl']};
  align-items: flex-start;
  max-width: 740px;
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.xl};
  align-items: flex-start;
  width: 100%;
`;

export const Header = styled.h2`
  ${heading['2Xl']};
  color: ${text.strong};
  margin: 0;
`;

export const Images = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing['2Xl']};
  align-self: stretch;

  @media screen and (min-width: ${breakpoint.sm}) {
    flex-direction: row;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    gap: ${spacing['4Xl']};
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: ${spacing.lg};
  flex: 1 0 0;
  width: 100%;

  @media screen and (min-width: ${breakpoint.sm}) {
    flex-direction: column;
    width: auto;
  }

  @media screen and (min-width: ${breakpoint.md}) {
    flex-direction: row;
  }
`;

export const ImageWrapper = styled.div`
  flex-shrink: 0;

  & img {
    width: 56px;
    height: 56px;
  }
`;

export const BlurbContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.lg};
  flex: 1 0 0;
`;

export const ImageTitle = styled.h3`
  ${heading.md};
  color: ${text.strong};
  margin: 0;
`;

export const ImageText = styled.p`
  ${body.regular.sm};
  color: ${text.default};
  margin: 0;
`;

export const TitleText = styled.p`
  ${body.regular.sm};
  color: ${text.default};
  margin: 0;
`;
